import SchedulingProvider from './SchedulingContext';
import Scheduling from './Scheduling';

let Index = () => {
    return (
        <SchedulingProvider>
            <Scheduling />
        </SchedulingProvider>
    )
}

export default Index;